export const EXTENSION_NAME = "one-siam-landing-page"
